import React, { Component } from 'react'
import styled from 'styled-components'

const StyledBbxInfoWidget = styled.div`
  margin-bottom: 16px;
  `

class BbxInfoWidget extends Component {
  shouldComponentUpdate () {
    return false
  }
  componentDidMount () {
    const s = document.createElement('script')
    s.src = 'https://sport.aktualne.cz/widget_code/e35d9cc2fbeb11ee9a9dac1f6b220ee8.js'
    s.setAttribute('data-widget-config', JSON.stringify({ insertInto: '#top-banner-container' }))
    document.body.appendChild(s)
  }

  render () {
    return (
      <StyledBbxInfoWidget id="top-banner-container"/>
    )
  }
}

export default BbxInfoWidget
